import {mapGetters} from "vuex";
import moment from "moment/moment";
import featureMixin from "@/mixins/featureMixin";
import ImageMagnifier from "@/components/image/ImageMagnifier.vue";
import router from "@/router";
import productHelperMixin from "@/mixins/productHelperMixin";

const urlHasProtocol = (url) => {
	let protocolRegex = /^(http|https|ftp|file):\/\//i;
	return protocolRegex.test(url);
}

export default {
	props: {
		product: {
			type: Object,
			required: true
		}
	},
	components: {
		ImageMagnifier
	},
	mixins: [featureMixin, productHelperMixin],

	computed: {
		...mapGetters(['language', 'lang', "isPreviewFlyer"]),
		...mapGetters('landingPage', ['currentFlyer']),
		...mapGetters('screen', ['flyerOrientation']),
		...mapGetters('raddar', ['isRaddar']),
		...mapGetters("config", ["features"]),

		priceQty() {
			const qty = this.extractProductProp('priceQuantity');
			if (qty) return `${qty}`;
			return '';
		},

		bodyEn() {
			if (this.config?.bilingualCopy) return this.extractProductProp('bodyFr') + '\n' + this.extractProductProp('bodyEn');
			const bodyEn = this.language === 'fr' ? this.extractProductProp('bodyFr') : this.extractProductProp('bodyEn')
			return bodyEn.replace(/\s\•/g, '\n•');
		},

		pricePrefix() {
			return this.language === 'fr' ? this.extractProductProp('salePricePrefixFr') : this.extractProductProp('salePricePrefixEn')
		},

		limitQty() {
			return this.extractProductProp('limitQty') || '';
		},

		rowSave() {
			return this.language === 'fr' ? this.extractProductProp('rowSaveFr') : this.extractProductProp('rowSaveEn')
		},
		rowPrice() {
			let p = this.extractProductProp('rowPrice')
			if (!p || p === '$NaN' || p === 'NaN$') {
				return '';
			}

			if (!isNaN(p)) {
				p = parseFloat(p).toFixed(2);
				if (this.language === 'fr') {
					p = p.replace('.', ',');
				}
			}
			return this.formatCurrency(p);
		},

		rowPriceUnit() {
			return this.extractProductProp('rowPriceUnit') || '';
		},

		rowPriceQty() {
			return this.extractProductProp('rowPriceQty') || '';
		},

		salePrice() {
			let price = this.extractProductProp('salePrice');

			if (!price || price === '$NaN' || price === 'NaN$') {
				return '';
			}

			if (!isNaN(price)) {
				price = parseFloat(price).toFixed(2);
				if (this.language === 'fr') {
					price = price.replace('.', ',');
				}
			}
			return this.formatCurrency(price);
		},
		memberPrice() {
			let price = this.extractProductProp('memberPrice')

			if (!price || price === '$NaN' || price === 'NaN$') {
				return '';
			}

			if (!isNaN(price)) {
				price = parseFloat(price).toFixed(2);
				if (this.language === 'fr') {
					price = price.replace('.', ',');
				}
			}
			return this.formatCurrency(price);
		},
		regularPrice() {
			let p = this.extractProductProp('regularPrice')
			if (!p || p === '$NaN' || p === 'NaN$') {
				return '';
			}

			if (!isNaN(p)) {
				p = parseFloat(p).toFixed(2);
				if (this.language === 'fr') {
					p = p.replace('.', ',');
				}
			}
			return this.formatCurrency(p);
		},

		tierEachPrice() {
			return this.extractProductProp('tierEachPrice') || '';
		},

		taxSuffix() {
			return this.extractProductProp('tx') || '';
		},
		memberPriceQty() {
			const qty = this.extractProductProp('memberPriceQuantity');
			if (qty) return `${qty}`;
			return '';
		},
		memberPricePrefix() {
			return this.extractProductProp('memberPricePrefix');
		},
		memberPriceUnit() {
			return this.extractProductProp('memberPriceUnit') || '';
		},
		memberSavePrefix() {
			return this.formatCurrency(this.extractProductProp('memberSavePrefix') || '');
		},
		memberSave() {
			return this.extractProductProp('memberSave')
		},
		memberSaveSuffix() {
			return this.extractProductProp('memberSaveSuffix');// this.language === 'en' ? this.extractProductProp('memberSaveSuffixEn') : this.extractProductProp('memberSaveSuffixFr')
		},
		alternatePrice() {
			return this.formatCurrency(this.extractProductProp('alternatePrice')) || '';
		},
		promoUnit() {
			return this.extractProductProp('promoUnit');
		},
		priceLine() {
			return `${this.priceQty}${this.pricePrefix}${this.salePrice} ${this.promoUnit}`;
		},
		savings() {
			if (this.config.hideSavings) return '';
			return this.extractProductProp('savings')
		},
		savingsPrefix() {
			return this.extractProductProp('savingsPrefix')
		},
		savingsSuffix() {
			return this.extractProductProp('savingsSuffix')
		},
		loyalty() {
			return this.extractProductProp('loyalty');
		},
		loyaltyPrefix() {
			return this.extractProductProp('loyaltyPrefix');
		},
		loyaltySuffix() {
			return this.extractProductProp('loyaltySuffix');
		},

		productName() {
			return this.extractProductProp('product');
		},
		description() {
			if (this.config.hideDetails) return '';
			return this.extractProductProp('body')
		},
		htmlDescription() {
			return this.description.replace(/\*\*/g, '<br>**').replace(/(^|\s)\*(?=\S)/g, '<br>*').replace(/-/g, '&#x2011;');
		},
		productURLLDF() {

			let utm_source = this.isRaddar ? 'raddar' : 'TC_hosted';
			const utm_medium = `digital_flyer`
			const formattedDate = this.currentFlyer.startDate?.split('T')[0].replace(/-/g, '')
			const flyerCategory = this.currentFlyer.flyerCategory?.replace(/ /g, '_').toLowerCase();
			const utm_campaign = `${flyerCategory}_${this.dealId?.replace(/ /g, '_')}_${formattedDate}`
			let utm;
			console.log("from PDP",this.product.url)
			const locParam = this.features.pdp.locParam;
			if (this.product.url.includes('?')) {
				utm = locParam
					? `&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&loc=${locParam}`
					: `&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
			} else {
				utm = locParam
					? `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&loc=${locParam}`
					: `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
			}

			if (this.config.productURL) {
				return this.config.productURL.replaceAll('${sku}', this.sku);
			}
			let url = this.extractProductProp('url');
			if (!url) return url;

			if (!urlHasProtocol(url)) {
				url = `https://${url}`;
			}
			return `${url}${utm}`;
		},
		isProductURL() {
			if (this.features?.pdp?.disableShopNow && this.isPreviewFlyer) return;
			return this.product?.url ?? false;
			//return (this.product?.url && this.language === 'en') ? this.product.url : false
		},
		productURL() {
			
			if (this.config.productURL) {

				return this.config.productURL
					.replaceAll('${sku}', this.sku)
					.replaceAll('/en/', '/' + this.language + '/');
			}
			let url = this.extractProductProp('url');

			if (!url) return url;

			if (!urlHasProtocol(url)) {
				url = `https://${url}`;
			}

			if (!url) {
				const clickRegionWithUrl = this.product.clickRegions.find(clickRegion => clickRegion.url)
				if (clickRegionWithUrl) {
					url = clickRegionWithUrl.url;
				}
			}


			return url;
		},
		productImage() {
			if (this.extractProductProp('productImage') === '' && this.config.useBlockImage) return this.product?.blockData?.images?.findLast((item) => {
				return item?.image;
			}).image;

			return this.extractProductProp('productImage');
		},
		sku() {
			return this.extractProductProp('sku');
		},
		showProductName() {
			return this.productName !== this.description;
		},
		useRow() {
			if(!this.validFromRow)return false;
			return this.currentDate.isBetween(this.validFromRow, this.validToRow, undefined, '[]');

			/*if (!this.extractProductProp('validFromROW')) return false;

			const vfr = moment(this.extractProductProp('validFromROW')).startOf('day');
			const vft = moment(this.extractProductProp('validToROW')).endOf('day');
			return moment().isBetween(vfr, vft);*/
		},
		validFrom() {
			if (this.config.useFlyerValidity) return this.formatDate(this.validFromFlyer);
			return this.formatDate(this.useRow ? this.validFromRow : this.validFromProduct || this.validFromFlyer);
			//return this.formatDate(this.useRow ? this.extractProductProp('validFromROW') : this.extractProductProp('validFrom') || this.currentFlyer.startDate);
		},
		validTo() {
			if (this.config.useFlyerValidity) return this.formatDate(this.validToFlyer);
			return this.formatDate(this.useRow ? this.validToRow : this.validToProduct || this.validToFlyer);
			//return this.formatDate(this.useRow ? this.extractProductProp('validToROW') : this.extractProductProp('validTo') || this.currentFlyer.endDate);
		},

		/**
		 * Retrieves the "validFrom" date property as a Date object and adjusts it to the start of the day.
		 * The "validFrom" property is expected to be stored and processed internally.
		 *
		 * @return {Moment|undefined} The "validFrom" date adjusted to the start of the day, or null if the property is unavailable or invalid.
		 */
		validFromProduct() {
			return this.getAsDate('validFrom')?.startOf('day');
		},

		/**
		 * Retrieves the 'validTo' date property, converts it to a JavaScript Date instance,
		 * and adjusts it to reflect the end of the corresponding day.
		 *
		 * @return {Moment|undefined} The 'validTo' date adjusted to the end of the day, or null if 'validTo' is not available.
		 */
		validToProduct() {
			return this.getAsDate('validTo')?.endOf('day');
		},

		/**
		 * Converts the `validFromROW` property of the product to a moment object if it exists.
		 *
		 * @return {Moment|undefined} A moment object representing the `validFromROW` date, or `undefined` if `validFromROW` is not defined.
		 */
		validFromRow() {
			return this.getAsDate('validFromROW')?.startOf('day');
		},

		/**
		 * Converts the `validToROW` property of the product to a Moment.js object,
		 * if the property exists.
		 *
		 * @return {Moment|undefined} Returns a Moment.js object representing the `validToROW` value,
		 * or undefined if `validToROW` does not exist.
		 */
		validToRow() {
			return this.getAsDate('validToROW')?.endOf('day');
		},

		/**
		 * Computes and returns the starting date of the current flyer set to the beginning of the day.
		 *
		 * @return {Moment} A Moment.js object representing the start date of the current flyer at the start of the day.
		 */
		validFromFlyer() {
			return moment.utc(this.currentFlyer.startDate, 'YYYY-MM-DD').startOf('day');
		},

		/**
		 * Determines the end of the day for the current flyer's end date.
		 *
		 * This method calculates the end of the day for the `endDate` property of the `currentFlyer` object
		 * using the Moment.js library.
		 *
		 * @return {Moment} A Moment.js object representing the end of the day of the current flyer's end date.
		 */
		validToFlyer() {
			return moment.utc(this.currentFlyer.endDate, 'YYYY-MM-DD').endOf('day');
		},

		/**
		 * Retrieves the current date, either from the `timeTravelDate` query parameter or defaults to the current system date converted to utc.
		 * If the `timeTravelDate` query parameter is invalid or not provided, the method returns the current date (UTC).
		 *
		 * @return {moment.Moment} A moment object representing either the parsed `timeTravelDate` or the current date (UTC).
		 */
		currentDate() {
			if(this.isPreviewFlyer)	{
				return this.validFromFlyer;
			}
			const date = moment.utc(router.currentRoute.query['timeTravelDate']);
			if(date.isValid() && router.currentRoute.query['timeTravelDate']) return date;

			return moment().utc();
		},

		htmlValidity() {
			return `<span class="date-item">${this.validFrom}</span> ${this.language === 'en' ? 'to' : 'jusqu\'au'} <span class="date-item">${this.validTo}</span>`;
		},

		isXDaySale() {
			if (this.product === null) return;

			return (this.validToProduct !== this.validToFlyer && this.validFromProduct !== this.validFromFlyer && this.validToRow !== this.validToFlyer && this.validFromRow !== this.validFromFlyer && moment(this.currentDate).isBetween(this.validFromProduct, this.validToProduct, undefined, '[]'))

			/*


			const date = this.currentDate;// router.currentRoute.query['timeTravelDate'] ?? moment();
			const startDate = this.validFromRow;// moment(this.product.validFromROW).startOf('day');// subtract(1, "days")
			const endDate = this.validToRow;// moment(this.product.validToROW).endOf('day');// add(1, "days")
			if ((this.validFromProduct !== this.validFromFlyer) && (this.validToProduct !== this.validToFlyer) ||
				(this.validFromRow !== this.validFromFlyer) && (this.validToRow !== this.validToFlyer)) {
				return moment(date).isBetween(startDate, endDate);
			} else
				return false*/

		},
		XDaySaleDates() {
			if (this.product === null || !this.validFromRow || !this.validToRow) return;
			let startDate, endDate;
			startDate = this.validFromRow;// moment(this.product.validFromROW)
			endDate = this.validToRow;// moment(this.product.validToROW)

			if (this.language === 'en') {
				return `${startDate.locale(this.language).format('MMMM D, YYYY')} to ${endDate.locale(this.language).format('MMMM D, YYYY')}`
			} else {
				return `${startDate.format('D MMM YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')} au ${endDate.format('D MMM YYYY').replace('1er', '1<sup style="vertical-align: top; font-size: 8px;">er</sup>')}`;
			}
		},
		showTierEachPrice() {
			return (!this.config.xDaySaleCheck && this.tierEachPrice && this.priceQty) || (this.config.xDaySaleCheck && this.isXDaySale && this.priceQty);
		},
	},
	methods: {
		//Moved To productHelperMixin
	}
}
